import {
  useMutation,
  useQueryClient,
  type UseMutateFunction,
  type UseMutateAsyncFunction,
} from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { Candidate } from '../types/candidate.types';

export function useDeleteCandidate(): {
  deleteCandidate: UseMutateFunction<Candidate, Error, string>;
  deleteCandidateAsync: UseMutateAsyncFunction<Candidate, Error, string>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => candidateService.deleteCandidate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['candidates'] });
    },
  });

  return {
    deleteCandidate: mutation.mutate,
    deleteCandidateAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
